import { render, staticRenderFns } from "./DrawalRecode.vue?vue&type=template&id=4c5b5f43&scoped=true"
import script from "./DrawalRecode.vue?vue&type=script&lang=js"
export * from "./DrawalRecode.vue?vue&type=script&lang=js"
import style0 from "./DrawalRecode.vue?vue&type=style&index=0&id=4c5b5f43&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b5f43",
  null
  
)

export default component.exports